﻿export function focusNextElement(currentElement: HTMLElement): void {
	requestAnimationFrame(function () {
		const focusableElements = Array.from(
			document.querySelectorAll<HTMLElement>(
				"a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex=\"-1\"])"
			)
		);
		const currentIndex = focusableElements.indexOf(currentElement);
		const nextElement = focusableElements[currentIndex + 1];
		nextElement?.focus();
	});
}
